import type { BacklogApiSpec as BacklogApiSpecContract } from "../../contracts/utils/metadata/BacklogApiSpec";
import type { MetaTypeKey } from "../../contracts/utils/metadata/MetaTypeKey";
import type { MetadataApiSpecInfo } from "../../contracts/utils/metadata/MetadataApiSpecInfo";
import { getMetaTypeKey } from "./BacklogMetaUtil";

export class BacklogApiSpec<T> implements BacklogApiSpecContract<T> {
	private readonly entity_key: MetaTypeKey<T>;
	constructor(public readonly info: MetadataApiSpecInfo) {
		// biome-ignore lint/suspicious/noExplicitAny: <explanation>
		const path = this.info.entity_path as any;
		this.entity_key = getMetaTypeKey(path) as MetaTypeKey<T>;
	}

	getEntityTypeKey(): MetaTypeKey<T> {
		return this.entity_key;
	}
}
